export const baseStyles = (isActive: boolean) => [
	"inline-flex",
	"items-center",
	"justify-center",
	isActive
		? "bg-button-normal-primary-default text-palette-gray-1"
		: "bg-button-normal-secondary-default text-palette-gray-11",
];

export const hoverStyles = (isActive: boolean) => [
	isActive ? "hover:bg-button-normal-primary-hover" : "hover:bg-button-normal-secondary-hover",
];
export const iconStyles = (isActive: boolean) => [];

export const disabledStyles = (isActive: boolean, isDisabled: boolean) =>
	isDisabled && [
		"cursor-not-allowed",
		isActive ? "[&_svg]:fill-icon-inverse-disabled" : "[&_svg]:fill-icon-disabled",
	];
